export const environment = {
  production: false,
  eliquaRestURL: 'https://hellenica.uat.qivos.net/ci-hellenica-UAT/rest/v1/',
  clientName: 'hellenica',
};
